__turbopack_context__.v({
  "ProseMirror": "zz2ejW_ProseMirror",
  "ProseMirror-gapcursor": "zz2ejW_ProseMirror-gapcursor",
  "dark": "zz2ejW_dark",
  "has-focus": "zz2ejW_has-focus",
  "is-active": "zz2ejW_is-active",
  "is-empty": "zz2ejW_is-empty",
  "node-aiImage": "zz2ejW_node-aiImage",
  "node-aiWriter": "zz2ejW_node-aiWriter",
  "node-imageBlock": "zz2ejW_node-imageBlock",
  "node-imageUpload": "zz2ejW_node-imageUpload",
  "node-sectionNode": "zz2ejW_node-sectionNode",
  "node-tableOfContentsNode": "zz2ejW_node-tableOfContentsNode",
  "plainEmphasis": "zz2ejW_plainEmphasis",
  "plainListMarkers": "zz2ejW_plainListMarkers",
  "shimmer": "zz2ejW_shimmer",
  "shimmer-text-animation": "zz2ejW_shimmer-text-animation",
});
